module.exports = __webpack_public_path__ + "img/logo-manage-dark.595f4897.png";